import { isDOM } from '@app/shared/predicates'

function trackVisit(): void {
  if (!window.Appcues) {
    return
  }

  window.Appcues.track('Page visit', {
    path: window.location.pathname,
    host: window.location.host,
    controller: window?.SfAppcueSettings?.controller,
    action: window?.SfAppcueSettings?.action,
  })
}

function toggleAppcuesLauncher(launchpadId: string): () => void {
  return function (): void {
    const appcuesRoot = document.getElementById(
      `appcues-container-${launchpadId}`
    )

    if (appcuesRoot) {
      appcuesRoot?.shadowRoot?.getElementById('launchpad-button')?.click()
    }
  }
}

function setupAppcuesButton(doc: Document): void {
  const helpMenuItem = doc.querySelector(
    '[data-behavior="sf-appcues-launcher"]'
  ) as HTMLElement

  if (helpMenuItem) {
    const launchpadId = helpMenuItem.getAttribute('data-launchpad-id') as string
    helpMenuItem.addEventListener('click', toggleAppcuesLauncher(launchpadId))
  }
}

function reloadAppcues(): void {
  window.onDomLoad(($dom) => {
    if (isDOM($dom[0])) {
      setupAppcuesButton($dom[0])

      trackVisit()
    }
  })
}

export default function setupAppcues(): () => void {
  window.eventHub.$on('appcues:loaded', trackVisit)

  reloadAppcues()

  return reloadAppcues
}
